import { ContentSectionResponse } from '@admin-shared/types/content';
import { ApiBase } from './api.base';


export class ContentApi extends ApiBase {
  model = 'content';

  teamContentByName(name: string) {
    return this.http.get<ContentSectionResponse[]>(this.buildUrl('team', name));
  }
}
